<!-- Navigation Bar-->
<nav class="navbar navbar-expand-lg navbar-dark bg-native shadow">
    <div class="container-fluid">
        <img src="assets/img/philippines.png" alt="Philippine History Timelines" class="d-inline-block align-top logo">
        <a class="navbar-brand" routerLink="/">History Timeline</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" aria-current="page" routerLink="/about">About</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/main-timeline">Main Timeline</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/famous-tags">Famous Tags</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/search-tags">Search Tags</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/associated-blogs">Associated Blogs</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/rss">RSS <i class="bi bi-rss"></i></a>

                </li>
                <li class="nav-item dropdown" *ngIf="auth.user | async as user; else showLogin">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        {{ user.displayName }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                        <li><a class="dropdown-item" routerLink="/profile/{{user.uid}}">Profile</a></li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li><a class="dropdown-item" (click)='logout()'>Logout</a></li>
                    </ul>
                </li>
                <ng-template #showLogin>
                    <li class="nav-item">
                        <button class="btn btn-light" (click)='login()' style="display:inline-block">
                            <img src="./assets/img/google-icon.png" style="float:left;margin-right:0.5em">Login</button>
                    </li>


                </ng-template>
            </ul>
        </div>
    </div>
</nav>

<!-- Body -->
<div class="container-fluid p-3">
    <router-outlet>
    </router-outlet>
</div>

<footer class="mt-4">
    <nav class="navbar fixed-bottom navbar-dark bg-native">
        <div class="container-fluid">
            <div class="text-end"><small>Icons made by <a href="https://www.flaticon.com/authors/freepik"
                        title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/"
                        title="Flaticon">www.flaticon.com</a></small></div>
        </div>
    </nav>
</footer>